import React from 'react'
import { Article } from './articles'
import '../../styles/ArticleCarouselModule/ArticleCard.scss'

interface ArticleCardProps {
  article: Article
  onSelect: (article: Article) => void
}

/**
 * A single article card. The whole card is a link that opens the article in a
 * new tab; clicking also reports the selection via `onSelect`.
 */
export const ArticleCard = ({ article, onSelect }: ArticleCardProps) => {
  return (
    <a
      className="article-card"
      data-testid="article-card"
      href={article.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => onSelect(article)}
    >
      <div className="article-card__image">
        {article.imageUrl && <img src={article.imageUrl} alt="" />}
      </div>
      {article.category && <span className="article-card__category">{article.category}</span>}
      <h3 className="article-card__title">{article.title}</h3>
      {(article.authorName || article.date) && (
        <div className="article-card__meta">
          {article.authorAvatarUrl && (
            <img className="article-card__avatar" src={article.authorAvatarUrl} alt="" />
          )}
          <div className="article-card__byline">
            {article.authorName && (
              <span className="article-card__author">Written by {article.authorName}</span>
            )}
            {article.date && <span className="article-card__date">{article.date}</span>}
          </div>
        </div>
      )}
    </a>
  )
}
